import { Button, message, Popover } from 'antd';
import React, { FC, useMemo, useState } from 'react';
import ViaStockLocationModal from './ViaStockLocationModal';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { connect } from 'react-redux';
import { isForwardingAllowedBySettings } from '../../utils/InventoryUtils';

const ViaStockLocationButton: FC<any> = ({
	purchaseOrder,
	companySettings,
}): React.ReactElement => {
	const [modalVisible, setModalVisible] = useState(false);

	const isLocationPO = useMemo(() => !!nullSafeGet('locationId', purchaseOrder), [purchaseOrder]);

	const _showModal = () => setModalVisible(true);
	const _hideModal = () => setModalVisible(false);

	const equipmentLineItems = useMemo(
		() => nullSafeGetOrElse('equipmentSupplierPurchaseOrderLineItems', purchaseOrder, []),
		[purchaseOrder]
	);

	const viaSLIdAlreadyExists = useMemo(
		() => equipmentLineItems.some((_) => !!_.viaStockLocationId),
		[equipmentLineItems]
	);

	const itemsReceivedAlready = useMemo(
		() => equipmentLineItems.some((_) => _.equipmentReceivedQuantity > 0),
		[equipmentLineItems]
	);

	const onSuccess = () => {
		_hideModal();
		message.success('Via stock location updated successfully!');
	};

	const disabledMessage = useMemo(
		() =>
			viaSLIdAlreadyExists
				? 'Update forwarding stock location in individual line items'
				: itemsReceivedAlready
				? 'Return received items to update forwarding stock location'
				: '',
		[itemsReceivedAlready, viaSLIdAlreadyExists]
	);

	return isLocationPO && isForwardingAllowedBySettings(companySettings) ? (
		<>
			<Popover trigger="hover" content={disabledMessage || ''}>
				<Button type="ghost" onClick={_showModal} disabled={!!disabledMessage}>
					Update Forwarding Stock Location
				</Button>
			</Popover>
			{modalVisible && (
				<ViaStockLocationModal
					purchaseOrder={purchaseOrder}
					onSuccess={onSuccess}
					onCancel={_hideModal}
				/>
			)}
		</>
	) : null;
};

const mapStateToProps = (state) => ({
	companySettings: state.company_config.detail,
});

export default connect(mapStateToProps)(ViaStockLocationButton);
